angular.module('aprima-core-ui')
    .directive('apTile', ['_', '$parse', function (_, $parse) {
        'use strict';

        return {
            restrict: 'EA',
            require: '^apTileManager',
            link: function(scope, element, attrs, tileManager) {
                var tileId = scope.$eval(attrs.tileId);
                var defaultValue;
                
                if(_.isNil(tileId)) {
                    throw new Error('apTile has to have a tile-id to work properly.');
                }

                if(!tileManager) {
                    throw new Error('apTile has to have apTileManager as a parent to work properly.');
                }

                if(attrs.isCollapsed) {
                    var parsedIsCollapsed = $parse(attrs.isCollapsed);
                    if(!parsedIsCollapsed.assign) {
                        throw new Error('apTile attribute is-collapsed must be an assignable value.');
                    }

                    defaultValue = !!parsedIsCollapsed(scope);
                    
                    var isCollapsedWatch = scope.$watch(
                        function(currentScope) {
                            return parsedIsCollapsed(currentScope);
                        }, 
                        function(newVal, oldVal) {
                            if(newVal !== oldVal) {
                                toggleTile();
                            }
                        }
                    );
                    scope.toggle = function toggle() {
                        parsedIsCollapsed.assign(scope, !parsedIsCollapsed(scope));
                    };
                    scope.tileState = tileManager.tileGroup.setupTile(tileId, defaultValue, true);
                }
                else {
                    defaultValue = !!scope.$eval(attrs.defaultCollapsed);
                    scope.toggle = toggleTile;
                    scope.tileState = tileManager.tileGroup.setupTile(tileId, defaultValue);
                }
                scope.scroller = attrs.scroller;

                function toggleTile() {
                    tileManager.tileGroup.toggle(tileId);
                }

                scope.$on('$destroy', function() {
                    if(isCollapsedWatch) {
                        isCollapsedWatch();
                    }
                });
            }
        };
    }]);
